import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";
import { LIGHT_GREY } from "../../utils/colors";

export const useStyles = makeStyles((theme: Theme) => ({
  root: { display: "flex" },
  rootActions: {
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  rootContent: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3, 2),
  },
  paper: {
    backgroundColor: `${LIGHT_GREY} !important`,
    padding: theme.spacing(1, 3),
  },
  btnPutList: {
    marginLeft: `${theme.spacing(2)} !important`,
  },
  textCoast: { display: "flex", alignItems: "baseline" },
  lineStepper: {
    borderColor: `${theme.palette.primary.main} !important`,
    margin: theme.spacing(0, 4),
  },
  rootStepper: { width: "45%" },
  stackStepper: {
    borderBottomColor: LIGHT_GREY,
    borderBottomWidth: 1,
    borderBottomStyle: "solid",
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  icon: {
    backgroundColor: LIGHT_GREY,
    marginRight: theme.spacing(1),
    padding: theme.spacing(0.5),
  },
}));
